<template>
  <div>
    <h1 class="text-center pt-4 mt-4">Sorry that's a 404!</h1>
    <h5 class="text-center mt-2 mb-5 pb-4">We couldn't find that page, please try again. <router-link to="/">Start New Booking.</router-link></h5>
  </div>
</template>
<script>
export default {
  name: 'PageNotFound'
}
</script>
